import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import FeatureTrack from "@/components/FeatureTrack";
import FeatureStreamline from "@/components/FeatureStreamline";
import FeatureAllInOne from "@/components/FeatureAllInOne";
import FeatureInsights from "@/components/FeatureInsights";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50/30 via-white to-blue-50/30 dark:from-gray-900 dark:via-gray-900 dark:to-gray-900 font-sans transition-colors duration-300 relative overflow-hidden">
      {/* Main Content */}
      <div className="relative z-10">
        <Header />
        <main className="pt-24">
          <Hero />
          <Stats />
          <About />
          <FeatureTrack />
          <FeatureStreamline />
          <FeatureAllInOne />
          <FeatureInsights />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Index;
